
const flavor = App.Constants.FLAVOR || 'maggie'
const routes = require('./local-router-' + flavor)

module.exports = routes
